<template>
    <div class="announcement">
        <!-- simple marquee text -->
        <marquee-text :duration="100">
            <div v-for="item in news" :key="item.id" class="news"
                  :class="{'text-danger': item.important == 1}">
                <i class="fa fa-bullhorn"></i>&nbsp;&nbsp;
                <span v-html="item.content"></span>
            </div>
            <div v-for="item in news" :key="item.id" class="news"
                         :class="{'text-danger': item.important == 1}">
                <i class="fa fa-bullhorn"></i>&nbsp;&nbsp;
                <span v-html="item.content"></span>
            </div>
            <div v-for="item in news" :key="item.id" class="news"
                  :class="{'text-danger': item.important == 1}">
                <i class="fa fa-bullhorn"></i>&nbsp;&nbsp;
                <span v-html="item.content"></span>
            </div>
        </marquee-text>
    </div>
</template>

<script>
import MarqueeText from "@/components/marquee-text.vue";

export default {
    name: "announcement-new",
    components: {MarqueeText},
    data() {
        return {
            news: [],
        }
    },
    props: {
        pad: {
            type: Boolean, default() {
                return false;
            }
        }
    },
    computed: {},
    methods: {
        loadAnnouncement() {
            this.$api('Announcement.newest', {}).then(res => {
                if (res.data.success) {
                    this.news = res.data.data;
                }
            });
        },
    },
    mounted() {
        this.loadAnnouncement();
    }
}
</script>

<style scoped lang="scss">
.pad-announcement {
    padding: 0 25px;

}

.announcement {
    margin-right: 10px;
    font-size: 13px;
    color: #666;
    line-height: 30px;
    overflow: hidden;


    .news {
        display: inline-block;
        white-space: nowrap;
        margin-right: 50px;
    }
}
</style>
